<template>
  <div>
    <div class="title--area">
        <h2>{{ menuNm }}</h2>
    </div>
    <div class="data--container" v-resize @resize="onResize">
      <div class="flex--box flex--box--1_2 btn--on" style="width:50%;">
        <div class="btn--area space--between"></div>
        <div class="grid--area">
          <grid ref="grid1"
              :data="gridTreeProps.data"
              :columns="gridTreeProps.columns"
              :options="gridTreeProps.options"
              :language="'ko'"
              @click="gridClick">
          </grid>
        </div>
      </div>
      <div class="flex--box flex--box--1_2 btn--on flex--box--black" style="width:50%;">
        <div class="btn--area">
          <div class="btns">
            <button type="button" class="btn btn--white" @click="search">조회</button>
            <button type="button" class="btn btn--white" @click="save">저장</button>
            <button type="button" class="btn btn--white" @click="excelDownload">엑셀다운로드</button>
            <button type="button" style="position: relative; z-index: 2; pointer-events: none;" class="btn btn--white" @change="excelUpload" @click="excelUpload">엑셀업로드</button>
              <input type="file" style=" position: absolute; right:32px; z-index: 1;" class="btn btn--white" @change="excelUpload" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"/>
          </div>
        </div>
        <table class="table">
          <caption>사용자관리 테이블</caption>
          <tbody>
            <tr>
              <th class="necessary">연도</th>
              <td>
                <select v-model="year" id="year">
                  <option :value="data" v-for="(data, idx) in yearList" v-bind:key="idx">{{ data }}</option>
                </select>
              </td>
              <th class="necessary">회차</th>
              <td>
                <select v-model="tmeNo" id="tmeNo">
                  <option :value="data" v-for="(data, idx) in tmeNoList" v-bind:key="idx">{{ data }}</option>
                </select>
              </td>
            </tr>
          </tbody>
        </table>
        <input type="hidden" name="saveFlg" id="saveFlg" value="N"/>
        <div class="grid--area">
          <grid ref="grid2"
              :data="gridProps.data"
              :columns="gridProps.columns"
              :options="gridProps.options"
              :language="'ko'"
              @check="gridCheck">
          </grid>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import 'tui-date-picker/dist/tui-date-picker.css'
import 'tui-time-picker/dist/tui-time-picker.css'
import { Grid } from '@toast-ui/vue-grid'
import $ from 'jquery'
import * as XLSX from 'xlsx'
import mapMngApi from '@/api/admin/MapMng'
import mapDataApi from '@/api/admin/MapDataMng'

export default {
  name: 'MapDataMng',
  components: {
    grid: Grid
  },

  data () {
    return {
      menuNm: this.$route.name,
      searchText: '',
      year: 'data',
      tmeNo: 'data',
      sidoIdCnt: 0,
      mapItmNoCnt: 0,
      yearList: [],
      tmeNoList: [],
      gridTreeProps: {
        data: [],
        columns: [
          {
            header: '목록ID',
            name: 'mapSysNo',
            width: 250
          },
          {
            header: '목록명',
            name: 'mapSysNm',
            width: 180
          },
          {
            header: '표시순번',
            name: 'dispOrdNo',
            width: 80,
            align: 'center'
          },
          {
            header: '주제명',
            name: 'categoryNm',
            width: 150
          },
          {
            header: '하위여부',
            name: 'lowerLevelYn',
            width: 80,
            align: 'center',
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '', value: '' },
                  { text: '예', value: 'Y' },
                  { text: '아니오', value: 'N' }
                ]
              }
            }
          },
          {
            header: '사용여부',
            name: 'useFlg',
            align: 'center',
            width: 80,
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '', value: '' },
                  { text: '예', value: 'Y' },
                  { text: '아니오', value: 'N' }
                ]
              }
            }
          },
          {
            header: '출처구분',
            name: 'srcCd',
            align: 'center',
            width: 100,
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '', value: '' },
                  { text: '승인통계', value: '1' },
                  { text: '지표통계', value: '2' },
                  { text: '행정통계', value: '3' },
                  { text: '기타', value: '4' }
                ]
              }
            }
          },
          {
            header: '출처번호',
            name: 'srcNo',
            width: 120,
            editor: 'text'
          },
          {
            header: '주기구분',
            name: 'tmeDivCd',
            align: 'center',
            width: 100,
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '', value: '' },
                  { text: '연', value: '1' },
                  { text: '분기', value: '2' },
                  { text: '월', value: '3' },
                  { text: '주', value: '4' },
                  { text: '수시', value: '5' }
                ]
              }
            }
          },
          {
            header: '지역구분',
            name: 'areaGbCd',
            align: 'center',
            width: 100,
            formatter: 'listItemText',
            editor: {
              type: 'select',
              options: {
                listItems: [
                  { text: '', value: '' },
                  { text: '시도', value: '1' },
                  { text: '시군구', value: '2' }
                ]
              }
            }
          }
        ],
        options: {
          header: {
            height: 40
          },
          columnOptions: {
            resizable: true
          },
          bodyHeight: 657,
          selectionUnit: 'cell',
          scrollX: true,
          scrollY: true,
          editingEvent: 'dblclick',
          treeColumnOptions: {
            name: 'mapSysNo',
            useIcon: true,
            useCascadingCheckbox: false
          }
        }
      },
      gridProps: {
        data: [],
        columns: [
          {
            header: '목록ID',
            name: 'mapSysNo',
            width: -1
          },
          {
            header: '연도',
            name: 'year',
            width: 120,
            align: 'center',
            validation: { required: true }
          },
          {
            header: '회차',
            name: 'tmeNo',
            width: 180,
            align: 'center',
            validation: { required: true }
          },
          {
            header: '시도ID',
            name: 'sidoId',
            width: 180,
            align: 'left',
            validation: { required: true }
          },
          {
            header: '시도',
            name: 'siNm',
            width: 180,
            align: 'left'
          },
          {
            header: '시군구ID',
            name: 'sigunguId',
            width: 180
          },
          {
            header: '시군구',
            name: 'sigunguNm',
            width: 180
          },
          {
            header: '항목ID',
            name: 'mapItmNo',
            width: 150,
            align: 'left',
            validation: { required: true }
          },
          {
            header: '항목',
            name: 'mapItmNm',
            width: 150,
            align: 'left'
          },
          {
            header: '수치',
            name: 'itmValue',
            width: 100,
            align: 'right',
            editor: 'text',
            formatter: (value) => {
              if (value.value !== null) {
                return String(value.value).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
              }
            }
          }
        ],
        options: {
          header: {
            height: 40
          },
          columnOptions: {
            resizable: true
          },
          bodyHeight: 550,
          selectionUnit: 'row',
          scrollX: true,
          scrollY: true,
          editingEvent: 'dblclick'
        }
      },
      rowKey: null,
      mapSysNo: '',
      areaGbCd: '',
      attribute: {
        expanded: true
      }
    }
  },

  mounted () {

  },

  created () {
    this.searchGridTreeData() // 상위 그리드 조회
  },

  methods: {
    onResize () {
      this.$refs.grid1.invoke('refreshLayout')
      this.$refs.grid2.invoke('refreshLayout')
    },
    // 상위 트리 그리드 조회
    async searchGridTreeData () {
      const params = {}

      const mapSysMngData = await mapMngApi.mapSysMngList(params)
      this.gridTreeProps.data = mapSysMngData

      if (this.gridTreeProps.data !== undefined) {
        this.$set(this.gridTreeProps.data[0], '_attributes', this.attribute) // 1depth 트리 expand 적용

        for (let i = 0; i < this.gridTreeProps.data[0]._children.length; i++) { // 2depth 까지 트리 expand 적용
          this.$set(this.gridTreeProps.data[0]._children[i], '_attributes', this.attribute)
        }

        this.$refs.grid1.invoke('resetData', this.gridTreeProps.data)

        // 왼쪽 그리드 컬럼 disabled 설정
        this.$refs.grid1.invoke('disableColumn', 'srcCd')
        this.$refs.grid1.invoke('disableColumn', 'useFlg')
        this.$refs.grid1.invoke('disableColumn', 'lowerLevelYn')
        this.$refs.grid1.invoke('disableColumn', 'srcNo')
        this.$refs.grid1.invoke('disableColumn', 'srcCd')
        this.$refs.grid1.invoke('disableColumn', 'tmeDivCd')
        this.$refs.grid1.invoke('disableColumn', 'areaGbCd')

        // 오른쪽 그리드 컬럼 숨김 설정
        this.$refs.grid2.invoke('hideColumn', 'mapSysNo')
        this.$refs.grid2.invoke('hideColumn', 'mapItmNo')
        this.$refs.grid2.invoke('hideColumn', 'sidoId')
        this.$refs.grid2.invoke('hideColumn', 'sigunguId')
      }
    },

    // 왼쪽 그리드 클릭 시 오른쪽 그리드 조회하기
    gridClick (ev) {
      if (ev.targetType === 'cell') {
        this.rowKey = ev.rowKey
        this.mapSysNo = this.$refs.grid1.invoke('getValue', ev.rowKey, 'mapSysNo')
        this.areaGbCd = this.$refs.grid1.invoke('getValue', ev.rowKey, 'areaGbCd')

        this.searchGridData()
        this.setSaveFlg('N')
      }
    },

    // 하위 그리드 조회
    async searchGridData () {
      // 연도 데이터 조회
      const yearParams = {
        mapSysNo: this.mapSysNo
      }
      const yearData = await mapDataApi.mapTmeYearList(yearParams)
      // 연도 셀렉트 박스 값 넣기
      this.yearList.splice(0)
      for (let i = 0; i < yearData.length; i++) {
        if (i === 0) {
          this.year = yearData[i].year
        }
        this.yearList.push(yearData[i].year)
      }

      // 회차 데이터 조회
      const tmeNoParams = {
        mapSysNo: this.mapSysNo,
        year: this.year
      }
      const tmeNoData = await mapDataApi.mapTmeNoList(tmeNoParams)
      // 회차 셀렉트 박스 값 넣기
      this.tmeNoList.splice(0)
      for (let i = 0; i < tmeNoData.length; i++) {
        if (i === 0) {
          this.tmeNo = tmeNoData[i].tmeNo
        }
        this.tmeNoList.push(tmeNoData[i].tmeNo)
      }

      this.search() // 조회하기
    },

    async search () { // 조회버튼
      var mapDataMngData
      const params = {
        mapSysNo: this.mapSysNo,
        year: this.year,
        tmeNo: this.tmeNo
      }

      if (this.areaGbCd === '1') { // 시도별
        mapDataMngData = await mapDataApi.mapDataMngSidoList(params)

        for (let i = 0; i < mapDataMngData.length; i++) {
          mapDataMngData[i].sigunguId = 0 // 시군구ID에 0 넣어주기
        }
      } else if (this.areaGbCd === '2') { // 시군구별
        mapDataMngData = await mapDataApi.mapDataMngSigunguList(params)
      }
      this.gridProps.data = mapDataMngData
      this.$refs.grid2.invoke('resetData', this.gridProps.data)
    },

    // 하위 그리드 row 추가
    add () {
      if (this.rowKey == null) {
        alert('목록을 선택해주세요.')
      } else {
        this.$refs.grid2.invoke('appendRow', { mapSysNo: this.mapSysNo }, { focus: false })
      }
    },

    // 하위 그리드 체크박스 선택 이벤트
    gridCheck (ev) {
      if (this.$refs.grid2.invoke('getValue', ev.rowKey, 'mapItmNo') == null) {
        this.$refs.grid2.invoke('removeRow', ev.rowKey)
      }
    },

    // 그리드 내 입력, 수정 event
    async save () {
      var saveFlg = $('#saveFlg').val()
      const params = []
      const rowCnt = this.$refs.grid2.invoke('getRowCount')
      var sidoId
      var mapItmNo

      for (let i = 0; i < rowCnt; i++) {
        sidoId = this.$refs.grid2.invoke('getRowAt', i).sidoId
        mapItmNo = this.$refs.grid2.invoke('getRowAt', i).mapItmNo
        if (sidoId == null) {
          this.sidoIdCnt = this.sidoIdCnt + 1
        }
        if (mapItmNo == null) {
          this.mapItmNoCnt = this.mapItmNoCnt + 1
        }
      }

      if (this.sidoIdCnt > 0 && this.mapItmNoCnt > 0) {
        alert('등록되지 않은 시도(' + this.sidoIdCnt + ')와 항목(' + this.mapItmNoCnt + ')이 있습니다.')
        return
      } else if (this.sidoIdCnt > 0) {
        alert('등록되지 않은 시도(' + this.sidoIdCnt + ')가 있습니다')
        return
      } else if (this.mapItmNoCnt > 0) {
        alert('등록되지 않은 항목(' + this.mapItmNoCnt + ')이 있습니다')
        return
      }

      if (saveFlg === 'N') { // saveFlg 가 N이라면
        const param = this.$refs.grid2.invoke('getModifiedRows') // createdRows, updatedRows, deletedRows

        if (param.createdRows.length === 0 && param.updatedRows.length === 0) { // 추가 또는 수정된 row가 없다면 이벤트 발생없이 return
          return
        }

        for (let i = 0; i < rowCnt; i++) { // 그리드2의 row갯수만큼 for문
          params.push(this.$refs.grid2.invoke('getRowAt', i))
        }
        if (window.confirm('저장하시겠습니까?')) {
          const result = await mapDataApi.insertMapDataMng(params)

          if (result.result) {
            alert('저장되었습니다.')
            this.searchGridData()
          } else {
            alert('오류가 발생했습니다. 다시 시도해주세요.')
          }
        }
      } else { // saveFlg 가 Y라면 (엑셀이 업로드 되었다면)
        for (let i = 0; i < rowCnt; i++) { // 그리드2의 row갯수만큼 for문
          params.push(this.$refs.grid2.invoke('getRowAt', i))
        }
        if (window.confirm('저장하시겠습니까?')) {
          const result = await mapDataApi.insertMapDataMng(params)

          if (result.result) {
            alert('저장되었습니다.')
            this.searchGridData()
          } else {
            alert('오류가 발생했습니다. 다시 시도해주세요.')
          }
        }
      }
    },

    // 엑셀 업로드
    async excelUpload (ev) {
      var siNm
      var mapItmNm

      if (this.mapSysNo == null) {
        alert('목록을 선택해주세요!')
        return
      }

      const file = ev.target.files[0]
      let tmpResult = {}
      const reader = new FileReader()

      reader.onload = () => {
        const fileData = reader.result
        const wb = XLSX.read(fileData, { type: 'binary' })
        wb.SheetNames.forEach((sheetName) => {
          wb.Sheets[sheetName].A1.w = 'year'
          wb.Sheets[sheetName].B1.w = 'tmeNo'
          wb.Sheets[sheetName].C1.w = 'siNm'
          wb.Sheets[sheetName].D1.w = 'sigunguNm'
          wb.Sheets[sheetName].E1.w = 'mapItmNm'
          wb.Sheets[sheetName].F1.w = 'itmValue'

          tmpResult = XLSX.utils.sheet_to_json(wb.Sheets[sheetName])
        })
      }

      reader.readAsBinaryString(file)
      reader.onloadend = async () => {
        this.$refs.grid2.invoke('resetData', tmpResult)

        for (let i = 0; i < tmpResult.length; i++) {
          siNm = tmpResult[i].siNm
          mapItmNm = tmpResult[i].mapItmNm

          const params = {
            mapSysNo: this.mapSysNo,
            siNm: siNm,
            mapItmNm: mapItmNm
          }

          const resultDataMapKey = await mapDataApi.mapDataSidoItmMng(params)

          this.$refs.grid2.invoke('setValue', i, 'mapSysNo', this.mapSysNo)
          this.$refs.grid2.invoke('setValue', i, 'sidoId', resultDataMapKey[0].sidoId)
          this.$refs.grid2.invoke('setValue', i, 'sigunguId', '0')
          this.$refs.grid2.invoke('setValue', i, 'mapItmNo', resultDataMapKey[0].mapItmNo)
        }
        this.setSaveFlg('Y') // 엑셀 업로드 플래그 Y
      }
    },

    excelDownload () {
      this.$refs.grid2.invoke('export', 'xlsx', { fileName: 'test' })
    },

    setSaveFlg (val) { // 엑셀업로드 플래그
      $('#saveFlg').val(val)
    }
  }

}
</script>

<style scoped>

</style>
